import { ExerciseConverted, ExerciseState } from '@/interfaces/class/exercises';
import { TrainingResult } from '@/interfaces/class/training';

const finishAction = (state: ExerciseState) => ({
  id: state.exercises?.class?.required?.[0]?.id,
});

const nextSlideAction = (state: ExerciseConverted) => {
  const nextSlide = state.currentSlide + 1;
  const key = state.currentScreen ? 'data' : 'dataTraining';

  if ((state.currentScreen === 'card' || !state.currentScreen) && nextSlide > state[key].length - 1) {
    return {
      currentSlide: 0,
      isFinishedExercise: state.currentScreen !== 'card',
    };
  }

  return {
    answers: {},
    isFinishedExercise: false,
    isFinishedTraining: false,
    currentSlide: nextSlide,
    lastTraining: null,
    lastIndexClick: null,
    lastIsCorrect: null,
    lastActiveAudio: null,
    lastTextClick: null,
    lastSlideAnswer: null,
  };
};

const previousSlideAction = (state: ExerciseConverted) => {
  const prevSlide = state.currentSlide - 1;
  const key = state.currentScreen ? 'data' : 'dataTraining';

  if (prevSlide < 0) {
    return {
      currentSlide: state[key].length - 1,
    };
  }

  return {
    answers: {},
    isFinishedExercise: false,
    isFinishedTraining: false,
    currentSlide: prevSlide,
    lastTraining: null,
    lastIndexClick: null,
    lastIsCorrect: null,
    lastActiveAudio: null,
    lastTextClick: null,
    lastSlideAnswer: null,
  };
};

const tryAgainAction = () => ({
  answers: {},
  currentSlide: 0,
  isFinishedTraining: false,
  isFinishedExercise: false,
});

const checkClickAction = (result: any) => ({
  isFinishedTraining: result.isCorrect,
});

const checkPartAction = (
  state: ExerciseConverted,
  result: any,
) => {
  const { currentSlide, dataTraining } = state;
  const results = Object.keys(result);
  const lastResult = results[results.length - 1];

  // @ts-ignore
  dataTraining[currentSlide].partResults = result;

  // @ts-ignore SC-2573 - error in WordToGap with numbers as answers
  if (dataTraining[currentSlide]?.allAllowedTrainingTypes?.[0] === 'WordToGap') {
    return {
      dataTraining,
    };
  }

  if (result[lastResult] && result[lastResult].isCorrect) {
    const part = dataTraining[currentSlide].enFillersShuffled?.[result[lastResult].text] || {};

    if (dataTraining[currentSlide] && dataTraining[currentSlide].enFillersShuffled) {
      // @ts-ignore
      dataTraining[currentSlide].enFillersShuffled[result[lastResult].text] = {
        ...part,
        // @ts-ignore
        count: (part.count || 1) - 1,
      };
    }
  }

  return {
    dataTraining,
  };
};

const nextExerciseAction = (currentExercise: ExerciseConverted) => ({
  id: currentExercise.nextExercise?.id || currentExercise.id,
  lastActiveAudio: null,
});

const flipAction = () => ({
  isFinishedTraining: true,
});

const checkTypeAction = (answers: any) => ({
  answers,
});

const updateClassState = (
  state: {
    exercise: ExerciseState;
  },
  btnType: string,
  trainingResult?: TrainingResult | {
    [key: number]: {
      userSet?: string;
      isCorrect: boolean;
      text: string;
    };
  },
  lastActivity?: {
    lastIndexClick?: number;
    lastTextClick?: string;
    lastIsCorrect?: boolean;
    lastSlideAnswer?: number | null;
  },
) => {
  if (state.exercise && state.exercise.currentExercise) {
    let result = {};

    switch (btnType) {
      case 'TRY_AGAIN':
      case 'START_AGAIN':
        result = tryAgainAction();
        break;
      case 'NEXT_SLIDE':
        result = nextSlideAction(state.exercise.currentExercise);
        break;
      case 'NEXT_EXERCISE':
        result = nextExerciseAction(state.exercise.currentExercise);
        break;
      case 'FINISH':
        result = finishAction(state.exercise);
        break;
      case 'PREV_SLIDE':
        result = previousSlideAction(state.exercise.currentExercise);
        break;
      case 'FLIP':
        result = flipAction();
        break;
      case 'CHECK_T_PART':
        result = {
          ...checkPartAction(state.exercise.currentExercise, trainingResult),
          ...(lastActivity || {}),
        };
        break;
      case 'CHECK_CLICK':
        result = {
          ...checkClickAction(trainingResult),
          ...(lastActivity || {}),
        };
        break;
      case 'CHECK_TYPE':
        result = checkTypeAction(trainingResult);
        break;
      case 'SET_ACTIVITY':
        result = lastActivity;
        break;
      case 'PRACTICE':
        result = {
          currentScreen: '',
          currentSlide: 0,
        };
        break;
      case 'DONT_KNOW':
      case 'CHECK':
        result = {
          isFinishedTraining: true,
        };
        break;
      case 'CHECK_PUZZLE':
      default:
        break;
    }

    return {
      exercise: {
        ...state.exercise,
        currentExercise: {
          ...result,
          lastUpdate: process.env.NODE_ENV === 'test' ? '' : new Date().getTime(),
        },
      },
    };
  }

  return {
    exercise: {},
  };
};

export {
  finishAction,
  nextSlideAction,
  previousSlideAction,
  tryAgainAction,
  checkClickAction,
  nextExerciseAction,
  checkPartAction,
  flipAction,
  checkTypeAction,
  updateClassState,
};
